import { FormikProps } from "formik";
import {
  AvisEditableList,
  IAvisEditableListFieldConfig,
  IEditableListRowState,
} from "../../../../shared/components/editableList";
import { AvisSection } from "../../../../shared/components/form";

interface IApplicationSectionBaseProps<
  T extends object,
  P extends IEditableListRowState,
> {
  bag: FormikProps<T>;
  bagField: keyof T;
  title: string;
  textToDisplay: string;
  fieldCollection: IAvisEditableListFieldConfig<P>[];
  initValue: P;
  disabled: boolean | undefined;
  loading: boolean | undefined;
  forceUpdateKey?: any;
  collapsable?: boolean;
}
export function ApplicationSectionBase<
  T extends object,
  P extends IEditableListRowState,
>(props: Readonly<IApplicationSectionBaseProps<T, P>>) {
  const {
    bag,
    bagField,
    title,
    textToDisplay,
    fieldCollection,
    initValue,
    forceUpdateKey,
    disabled,
    loading,
    collapsable = true,
  } = props;

  return (
    <AvisSection
      title={title}
      textToDisplayKey={textToDisplay}
      collapsable={collapsable}
    >
      <AvisEditableList<T, P>
        bag={bag}
        bagField={bagField}
        initValue={initValue}
        fields={fieldCollection}
        disabled={disabled}
        forceUpdateKey={forceUpdateKey}
        loading={loading}
      />
    </AvisSection>
  );
}
